var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGeoFences = function SvgGeoFences(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Zones"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M9.11986 1.56231L15.825 6.68455L11.4166 9.60033C11.0154 9.86567 10.86 10.379 11.0466 10.8223L13.0437 15.5674L4.81194 15.5674L2.13342 6.89948L9.11986 1.56231Z",
    fill: "#2E3744",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 2.33643,
    cy: 6.84521,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 4.76025,
    cy: 15.3501,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 12.8813,
    cy: 15.3501,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 11.0337,
    cy: 10.1548,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 15.4985,
    cy: 6.84521,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 9.11963,
    cy: 1.68848,
    r: 1.15479,
    fill: "#FAFAFA",
    stroke: "#2E3744"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGeoFences);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "geo_fences.7d5767f66f1e0665deb3e2d4e1d23b68.svg";